import * as PropTypes from 'prop-types';
import * as React from 'react';

class ShippingLabelHiddenAddressForm extends React.Component {
  phoneInput() {
    if (!this.props.includePhoneInput) { return null; }

    return (
      <input
        type="hidden"
        name={this.props.nameForInput('phone')}
        value={this.props.phone}
      />
    );
  }

  render() {
    return (
      <div className="hidden">
        <input
          type="hidden"
          name={this.props.nameForInput('name')}
          value={this.props.name}
        />
        <input
          type="hidden"
          name={this.props.nameForInput('street_address')}
          value={this.props.streetAddress}
        />
        <input
          type="hidden"
          name={this.props.nameForInput('extended_address')}
          value={this.props.extendedAddress}
        />
        <input
          type="hidden"
          name={this.props.nameForInput('locality')}
          value={this.props.locality}
        />
        <input
          type="hidden"
          name={this.props.nameForInput('region')}
          value={this.props.region}
        />
        <input
          type="hidden"
          name={this.props.nameForInput('postal_code')}
          value={this.props.postalCode}
        />
        <input
          type="hidden"
          name={this.props.nameForInput('countryCode')}
          value={this.props.countryCode}
        />
        {this.phoneInput()}
      </div>
    );
  }
}

ShippingLabelHiddenAddressForm.propTypes = {
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  nameForInput: PropTypes.func.isRequired,
  includePhoneInput: PropTypes.bool.isRequired,
};

export default ShippingLabelHiddenAddressForm;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/hidden_address_form.jsx